import type { Step } from "react-joyride";

export const formsTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການຟອມ! ຟອມແມ່ນແບບຟອມດິຈິຕອນທີ່ໃຊ້ສໍາລັບການລວບລວມຂໍ້ມູນຈາກຜູ້ໃຊ້. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="forms-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມສ້າງຟອມໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງຟອມທີ່ທ່ານຕ້ອງການ. ຟອມຈະຊ່ວຍທ່ານລວບລວມຂໍ້ມູນຈາກຜູ້ໃຊ້ຕາມຄວາມຕ້ອງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="forms-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາຟອມຕາມຊື່, ປະເພດ, ຫຼືສະຖານະ. ກົດປຸ່ມ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="forms-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງຟອມທັງໝົດ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ວິເຄາະ, ຫຼືລຶບຟອມໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະຟອມ. ທ່ານຍັງສາມາດກົດເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມຂອງຟອມແຕ່ລະຕົວ.",
    placement: "top",
  },
];
